// @constants
const { FIRST_STEP, SECOND_STEP } = require('constants/index');
const actionTypes = require('../raConstants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');

// @actions
const { updateSimulation } = require('./RASimulation');

const resetStep = step => ({
    type: actionTypes.RA_SET_GOAL_RESET,
    payload: {
        step,
    },
});

const updateGoalSelected = goalSelected => ({
    type: actionTypes.RA_UPDATE_SELECTED_GOAL,
    payload: {
        goalSelected,
    },
});

const setInvestmentGoalValue = (key, value) => ({
    type: actionTypes.RA_SET_GOAL_SET_INVESTMENT_GOAL_VALUE,
    payload: {
        key,
        value,
    },
});

const setVisibleStep = step => ({
    type: actionTypes.RA_SET_GOAL_SET_VISIBLE_STEP,
    payload: {
        step,
    },
});

const validateUIStep = step => ({
    type: actionTypes.RA_SET_GOAL_VALIDATE_UI_STEP,
    payload: {
        step,
    },
});

const setDateError = () => ({
    type: actionTypes.RA_SET_GOAL_DATE_ERROR_ENABLED,
});

const setFromSetGoal = () => ({
    type: actionTypes.RA_SET_FROM_SET_GOAL,
});

const getSimulation = () => (dispatch, getState) => {
    const immSimulation = getState().raSimulation.get('simulation');

    dispatch({
        type: actionTypes.RA_SET_GOAL_GET_DATA_FROM_SIMULATION,
        payload: immSimulation,
    });
};

const saveGoal = (callback = () => {}) => (dispatch, getState) => {
    const immRASetGoal = getState().raSetGoal;
    const immTimeHorizonCheck = getState().raTimeHorizonCheck;

    const update = {
        amount: immRASetGoal.getIn(['steps', SECOND_STEP, 'investmentAmount']),
        name: immRASetGoal.getIn(['steps', SECOND_STEP, 'investmentTitle']),
        endDate: immRASetGoal.getIn(['steps', SECOND_STEP, 'investmentDate']),
        maxTypeOfProduct: immTimeHorizonCheck.get('maxTypeOfProduct'),
        type: immRASetGoal
            .getIn(['steps', FIRST_STEP, 'goalTypeSelected'])
            .toUpperCase(),
    };

    dispatch(updateSimulation(update));

    const simulation = getState()
        .raSimulation.get('simulation')
        .toJS();
    simulation.pureRobo = false;
    const requestData = {
        header: {
            version: 2,
        },
        query: simulation,
    };

    return APIPost(dispatch, apiURLBuilder.getURL('raSimulation'), requestData)
        .then(() => {
            callback();
        })
        .catch(error => {
            callback();
            if (error.error) {
                dispatch(() => {});
            } else {
                throw error;
            }
        });
};

const validateStep = step => (dispatch, getState) => {
    dispatch(validateUIStep(step));
    let valid;
    switch (step) {
        case FIRST_STEP:
            valid = getState().raSetGoal.getIn(['steps', FIRST_STEP, 'valid']);
            if (valid) {
                dispatch(setVisibleStep(step + 1));
            }
            break;
        case SECOND_STEP:
            valid = getState().raSetGoal.getIn(['steps', SECOND_STEP, 'valid']);
            if (valid) {
                dispatch(setVisibleStep(step + 1));
            }
            break;
        default:
            break;
    }
};

const validateResidentiality = (profile, type) => ({
    type: actionTypes.RA_NONRESIDENTIAL_MODAL_VALIDATION,
    payload: {
        profile,
        type,
    },
});

const closeNonresidentialModal = () => ({
    type: actionTypes.RA_NONRESIDENTIAL_MODAL_CLOSE,
});

module.exports = {
    getSimulation,
    resetStep,
    saveGoal,
    setDateError,
    setFromSetGoal,
    setInvestmentGoalValue,
    setVisibleStep,
    updateGoalSelected,
    validateStep,
    validateResidentiality,
    closeNonresidentialModal,
};
